<template>
  <v-app :style="getAppDirection()">
    <div :style="showScrollBtn ? 'display: block;' : 'display: none'">
      <div class="sroll-to-top-btn-container">
        <router-link
          to=""
          v-scroll-to="{
            el: '#top',
            duration: 800,
            easing: 'ease-in'
          }"
          style="color: #1d1d1d;"
        >
          <font-awesome-icon
            :icon="['fas', 'sort-up']"
            size="2x"
            color="#1d1d1d"
            style="margin-top: 14px;"
          />
        </router-link>
      </div>
    </div>
    <!-- navigation bar -->
    <div id="top">
      <NavigationBar />
    </div>

    <!-- router -->
    <router-view></router-view>

    <!-- footer -->
    <div id="footer">
      <Footer />
    </div>
  </v-app>
</template>

<script>
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import WOW from "wow.js";

export default {
  name: "App",
  components: {
    NavigationBar,
    Footer
  },
  data() {
    return {
      lang: "en",
      showScrollBtn: false
    };
  },
  mounted() {
    new WOW().init();
    window.addEventListener("scroll", this.onScroll);
  },
  methods: {
    getAppDirection() {
      if (this.$i18n.locale === "en")
        return {
          direction: "ltr",
          fontFamily: "englishfont"
        };
      else
        return {
          direction: "rtl",
          fontFamily: "kurdishfont"
        };
    },
    getDisplayScrollBtn() {
      return window.scrollY > 100 ? "display: block;" : "display:none;";
    },
    onScroll() {
      window.scrollY > 100
        ? (this.showScrollBtn = true)
        : (this.showScrollBtn = false);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="scss">
$primaryColor: #cedb2d;

.yellowColor {
  color: $primaryColor;
}
.primaryColor {
  color: $primaryColor;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

@font-face {
  font-family: "kurdishfont";
  src: url("./fonts/DroidKufi-Regular.woff") format("truetype");
}

@font-face {
  font-family: "englishfont";
  src: url("./fonts/Quicksand-Regular.ttf") format("truetype");
}

:root {
  scrollbar-color: $primaryColor white; /* thumb and track color */
  scrollbar-width: thin;
}
::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-thumb {
  border-radius: 12px;
  background-color: $primaryColor;
}
::-moz-selection {
  color: $primaryColor;
  background: $primaryColor;
}
::selection {
  color: white;
  background: $primaryColor;
}
@media (max-width: 768px) {
  :root {
    scrollbar-color: $primaryColor white; /* thumb and track color */
    scrollbar-width: thin;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 6spx;
    background-color: $primaryColor;
  }
}
@media (max-width: 625px) {
  :root {
    scrollbar-width: none;
  }
  ::-webkit-scrollbar {
    width: 2px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
  }
}

#app {
  background-color: #1d1d1d;
}

.rtl {
  direction: "rtl";
}
.ltr {
  direction: "ltr";
}

.ml20 {
  margin-left: 20px;
}
.mr20 {
  margin-right: 20px;
}

p,
a,
h1,
h2,
h3,
h4,
h5,
h6,
button {
  color: #fefde5;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
}
p {
  font-size: 18px;
}
@media (max-width: 1440px) {
  p {
    font-size: 16px;
  }
}
@media (max-width: 768px) {
  p {
    font-size: 14px;
  }
}

@media (max-width: 625px) {
  h1 {
    font-size: 32px;
  }
}

select:focus,
input:focus,
textarea:focus {
  outline-color: $primaryColor;
}
button:focus {
  outline: none;
}

// section header
.section-container {
  width: 50%;
  margin: auto;
  text-align: center;
  padding-bottom: 200px;
}
.section-container h1 {
  font-size: 44px;
}
.section-header-underline {
  width: 70px;
  margin: auto;
  height: 4px;
  background-color: $primaryColor;
  border-radius: 10px;
  margin-bottom: 50px;
  margin-top: 25px;
}
@media (max-width: 768px) {
  .section-container {
    width: 75%;
    padding-bottom: 100px;
  }
  .section-container h1 {
    font-size: 36px;
  }
}
@media (max-width: 625px) {
  .servide-header-container {
    width: 90%;
  }
  .section-container h1 {
    font-size: 32px;
  }
}
// section header

// round link
.round {
  padding: 12px 34px;
  border-radius: 30px;
  border: 1px solid $primaryColor;
  color: #fefde5;
  transition: all 0.2s ease-out;
  font-weight: bolder;
}
.round:hover {
  color: #282828;
  background-color: $primaryColor;
}
// round link
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #282828;
  opacity: 0.8;
  z-index: 1;
}

// sroll-to-top
.sroll-to-top-btn-container {
  position: fixed;
  z-index: 100;
  bottom: 4%;
  right: 4%;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: $primaryColor;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 625px) {
  .sroll-to-top-btn-container {
    right: 5%;
    width: 50px;
    height: 50px;
  }
}
//  sroll-to-top

// full screen image with text
.full-screen-image-with-text-wrapper {
  position: relative;
  z-index: 2;
  width: 55%;
  height: 100vh;
  margin: auto;
  text-align: center;
  padding-top: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.full-screen-image-with-text-title-con {
  margin-bottom: 100px;
}
.full-screen-image-with-text-title-con h1 {
  font-size: 66px;
}
.full-screen-image-with-text-scrollcon {
  text-align: center;
  padding-top: 50px;
}
@media (max-width: 768px) {
  .full-screen-image-with-text-wrapper {
    width: 100%;
  }
  .full-screen-image-with-text-con {
    margin: 0;
    width: 100%;
    padding: 0px 24%;
  }
  .full-screen-image-with-text-title-con {
    margin-bottom: 50px;
  }
  .full-screen-image-with-text-title-con h1 {
    font-size: 46px;
  }
}
@media (max-width: 625px) {
  .full-screen-image-with-text-title-con h1 {
    font-size: 36px;
  }
}
@media (max-width: 525px) {
  .full-screen-image-with-text-title-con h1 {
    font-size: 32px;
  }
}
@media (max-width: 425px) {
  .full-screen-image-with-text-con {
    padding: 0px 12%;
  }
  .full-screen-image-with-text-title-con h1 {
    color: #cedb2d;
  }
  .full-screen-image-with-text-scrollcon a {
    padding: 12px 24px;
  }
}
// full screen image with text
</style>
